
(function(){
      $.fn.runSlider = function(interval){
          return $('.tabs--slider').each(function(){
          var current = 0,
              interval = interval||6000,
              $slider = $(this)
                  .bind('mouseenter', function(){ 
                      if (ts) {
                          clearTimeout(ts);
                          ts = null;
                      }
                  })
                  .bind('mouseleave', function(){ 
                      if (!ts){
                         ts = setTimeout(rotate, interval); 
                      }
                  }),                
              ts = null,
              showSlide = function(n){
                  current = n;
                  $slider.find('.tabs--page')
                      .removeClass('__js_isActive')
                      .eq(current)
                      .addClass('__js_isActive')
                  $slider.find('.tabs--tab')
                      .removeClass('__js_isActive')
                      .eq(current)
                      .addClass('__js_isActive');
              },
              rotate = function(){
                  current++;
                  if (current>=$slider.find('.tabs--page').length) current = 0;
                  showSlide(current);
                  ts = setTimeout(rotate, interval);
              }

          $slider.find('.tabs--tab').bind('click', function(){
              current = $(this).index();
              sendStats('tabs', 'tab-'+parseInt(current+1), '');
              showSlide(current)
          });
          ts = setTimeout(rotate, interval);
      });
  }
})();

$('.tabs--slider').runSlider();
